/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FundHistoryLoanDtoFromFund
 */
export interface FundHistoryLoanDtoFromFund {
  /**
   *
   * @type {string}
   * @memberof FundHistoryLoanDtoFromFund
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof FundHistoryLoanDtoFromFund
   */
  name: string;
}

export function FundHistoryLoanDtoFromFundFromJSON(json: any): FundHistoryLoanDtoFromFund {
  return FundHistoryLoanDtoFromFundFromJSONTyped(json, false);
}

export function FundHistoryLoanDtoFromFundFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FundHistoryLoanDtoFromFund {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
  };
}

export function FundHistoryLoanDtoFromFundToJSON(value?: FundHistoryLoanDtoFromFund | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    name: value.name,
  };
}
